/** ロケーションと利用ゾーンの相関チェック */
export default {
  validate(
    value: string | undefined | null,
    { prefix }: { prefix: string }
  ): boolean {
    if (!value || !prefix) return true;

    // 末尾1桁以外が一致しているかチェック（例: jp-kest-11〜jp-kest-19、末尾0は不可）
    const regex = new RegExp(`^${prefix}[1-9]$`);
    return regex.test(value);
  },
};
